import React, {useEffect} from 'react'
import PropTypes from 'prop-types';
import { Tab, Tabs, Typography, Box } from '@mui/material';
// Container
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import AddIcon from '@mui/icons-material/Add';
// import HomeIcon from '@mui/icons-material/Home';
import AddLoanPage from '../../AddLoan/Pages/AddLoanPage';
// import LoggedInNav from '../../../../../Layouts/LoggedInNav/LoggedInNav';
// import LenderLandingPageTakeDos from './LenderLandingPageTakeDos';

import LoggedInNavMui from '../../../../../Layouts/LoggedInNav/LoggedInNavMui';
// import LoggedInNavMUITakeDos from '../../../../../Layouts/LoggedInNav/LoggedInNavMUITakeDos';
// import LoggedOutNav from '../../../../../Layouts/LoggedoutNav/LoggedOutNav';

// import logo from '../../../../../assests/logo.jpg'

 
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role='tabpanel'
        hidden={value !== index}
        id={`vertical-tabpanel-${index}`}
        aria-labelledby={`vertical-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box
            sx={{
              p: 0,
              width: 'calc(85vw)',
              height: '100%',
              marginLeft: '200px',
              backgroundColor:'white',
              marginTop:'0%'
            }}
          >
            <Typography component={'span'}>{children}</Typography>
            {/* <Typography component={'div'}>{children}</Typography> */}
          </Box>
  
        )}
      </div>
    );
  }
  
  TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };
  
  function a11yProps(index) {
    return {
      id: `vertical-tab-${index}`,
      'aria-controls': `vertical-tabpanel-${index}`,
    };
  }

function VerticalTabs(props) {
    //   const loggedInUser = useSelector((state) => state.user.value);
    //   const navigate = useNavigate();
    
      useEffect(() => {
        checkUserCredentials();
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, []);
    
      const checkUserCredentials = () => {
    
    
        // if (
        //   !loggedInUser.username ||
        //   !loggedInUser.password ||
        //   !loggedInUser.userType
        // ) {
        //   navigate('/login');
        // } else {
        //   if (!loggedInUser) {
        //     navigate('/login');
        //   }
        // }
      };
    
      const [value, setValue] = React.useState(0);
    
      const handleChange = (event, newValue) => {
        setValue(newValue);
      };
    
      return (
        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            marginTop: '0%',
            bgcolor: 'background.paper',
          }}
        >
          <Tabs
            orientation='vertical'
            // variant='scrollable'
            value={value}
            onChange={handleChange}
            aria-label='Vertical tabs example'
            sx={{
              borderRight: 1,
              borderColor: 'divider',
              minWidth: '10px',
              position: 'fixed',
              bgcolor: 'background.paper',
              // minHeight: '400px',
              height: '100%',
              zIndex: 0,
              backgroundColor:'#121212',
              backgroundImage:'linear-gradient(rgba(255, 255, 255, 0.09), rgba(255, 255, 255, 0.09))',
              color:'white',
              marginTop:'0%'
    
            }}
          >
            {/* <Container disabled>
              <img src={logo} width='50' height='50'></img>
            </Container> */}
            {/* <Tab icon={<HomeIcon alt="lender home"/>} sx={{color:'white'}} {...a11yProps(0)}/> */}
            <Tab icon={<AddIcon alt="add"/>} sx={{color:'white'}} {...a11yProps(0)} />
            <Tab  icon={<CalendarTodayIcon alt="calendar"/>} sx={{color:'white'}} {...a11yProps(1)}/>
          </Tabs>

          {/* <TabPanel value={value} index={0}>
            <LenderLandingPageTakeDos/>
          </TabPanel> */}
    
    
          <TabPanel value={value} index={0}>
            <AddLoanPage/>
          </TabPanel>
    
          <TabPanel value={value} index={1}>
            <CalendarTodayIcon/>
          </TabPanel>
         
        </Box>
      );
    }
export default function LenderLandingPage() {
  return (
    <div>
      {/* <LoggedInNav/> */}
      <LoggedInNavMui/>
      {/* <LoggedInNavMUITakeDos/> */}
      <VerticalTabs/>
        
        {/* <LoggedOutNav/> */}
        {/* LenderLandingPage */}
        
    </div>
  )
}
